import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useHistory } from 'react-router-dom';
import { formatPrice } from '~/util/format';
import PaymentStatusSteps from '~/components/PaymentStatusSteps';
// eslint-disable-next-line import/no-extraneous-dependencies

import { toast } from 'react-toastify';
import * as S from './styles';
// import { Bottlesheet } from '../Bottlesheet';
import apiOffstorePay from '../../../../../services/offstorePay';

export function PaymentPageComponent({ transactionId }) {
  const history = useHistory();
  const [initialLoading, setInitialLoading] = useState(true);
  // const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [amount, setAmount] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);
  const [liquidValue, setLiquidValue] = useState(null);
  const [totalFee, setTotalFee] = useState(0.0);
  const [transaction, setTransaction] = useState();
  const [creditData, setCreditData] = useState();
  const [modalRepaymentActive, setModalRepaymentActive] = useState(false);

  const [historyList, setHistoryList] = useState(null);

  const getDetailTransaction = async id => {
    try {
      const res = await apiOffstorePay.get(`/transactions/${id}`);
      // console.log(res.data);

      if (res && res.data) {
        const offstore_fee = parseFloat(res.data.transaction.offstore_fee) || 0;
        const zoop_fee = parseFloat(res.data.transaction.zoop_fee) || 0;
        const TotalFee = offstore_fee + zoop_fee;
        const amoun_t = parseFloat(res.data.transaction.amount);
        setAmount(amoun_t || 0);
        setPaymentStatus(res.data.transaction.status);
        setPaymentDate(res.data.transaction.created_at);
        setLiquidValue(amoun_t - offstore_fee - zoop_fee);
        setTotalFee(TotalFee);
        setHistoryList(res.data.history);
        setTransaction(res.data.transaction);
        setCreditData(res.data.creditData);
      }
    } catch (err) {
      toast.error('Ocorreu um erro ao carregar a transação');
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    getDetailTransaction(transactionId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionId]);

  const formatDate = date => {
    const dataObjeto = new Date(date);

    const pattern = "d 'de' MMMM 'de' yyyy 'às' HH:mm'h'";
    const dataFormatada = format(dataObjeto, pattern, { locale: ptBR });

    return dataFormatada;
  };

  const formatToBrazilianStyle = value => {
    const _format = Number(value);
    return _format.toLocaleString('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  async function handleRepaymentOrder() {
    try {
      await apiOffstorePay
        .post(`/transactions/repayment`, {
          zoopSellerId: transaction && transaction.zoop_seller_id,
          zoopTransactionId: transaction && transaction.zoop_transaction_id,
          amount: transaction && Math.round(transaction.amount * 100),
        })
        .then(response => {
          if (response.status === 200) {
            setPaymentStatus('canceled');
          }
        });
    } catch (err) {
      toast.error('Erro ao fazer reembolso');
    } finally {
      setModalRepaymentActive(false);
    }
  }

  return (
    <>
      {/* {initialLoading && <LoaderComponent active inline="centered" />} */}

      {!initialLoading && (
        <>
          {/* {openBottomSheet && (
            <Bottlesheet close={() => setOpenBottomSheet(false)} />
          )} */}
          <S.ContainerWrapper>
            <S.Header>Pagamento</S.Header>

            <S.PaymentWrapper>
              <S.Payment>R$ {formatToBrazilianStyle(amount)}</S.Payment>
              {paymentStatus === 'contested' && (
                <S.Tag>Pagamento contestado</S.Tag>
              )}
              {paymentStatus === 'reembolsado' && (
                <S.Tag>Pagamento Reembolsado</S.Tag>
              )}
            </S.PaymentWrapper>
            <S.Description>
              {paymentDate && formatDate(paymentDate)}
            </S.Description>
            <S.Divider />
          </S.ContainerWrapper>

          <S.ContainerWrapper>
            <S.Header>Pedido</S.Header>
            {transaction && (
              <S.LinkButton
                onClick={() =>
                  history.push(`/myorders/${transaction.order_id}`)
                }
              >
                Ver pedido{' '}
                <svg
                  width="21"
                  height="12"
                  viewBox="0 0 21 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 6H19.5714"
                    stroke="#0D85FF"
                    strokeWidth="1.71429"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.5708 11L19.5708 6L14.5708 1"
                    stroke="#0D85FF"
                    strokeWidth="1.71429"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </S.LinkButton>
            )}

            <S.Divider />
          </S.ContainerWrapper>

          <S.ContainerWrapper>
            {transaction.order && (
              <>
                <S.Header>Dados do cliente</S.Header>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  <S.Description>{transaction.order.email}</S.Description>
                  <S.Description>{transaction.order.name}</S.Description>
                  <S.Description>{transaction.order.whatsapp}</S.Description>

                  {transaction.order.address && (
                    <S.Description>
                      {transaction.order.address}, {transaction.order.number},{' '}
                      {transaction.order.neighborhood}, {transaction.order.city}{' '}
                      - {transaction.order.uf} - {transaction.order.cep}
                    </S.Description>
                  )}
                </div>
                <S.Divider />
              </>
            )}
          </S.ContainerWrapper>

          <S.ContainerWrapper>
            <S.Header>Forma de pagamento</S.Header>

            {transaction && transaction.type === 'credit' && (
              <>
                {creditData && (
                  <S.Description>
                    Cartão de crédito (final {creditData.last4_digits})
                  </S.Description>
                )}
              </>
            )}

            {transaction && transaction.type === 'pix' && (
              <>
                <S.Description>Pix</S.Description>
              </>
            )}

            <S.Divider />
          </S.ContainerWrapper>

          <S.ContainerWrapper>
            <S.Header>Dados do pagamento</S.Header>

            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <S.Description>Valor: {formatPrice(amount)}</S.Description>
              <S.Description>Tarifa: {formatPrice(totalFee)}</S.Description>
              <S.Description>Líquido: {formatPrice(liquidValue)}</S.Description>
            </div>
            <S.Divider />
          </S.ContainerWrapper>

          {historyList && historyList.length > 0 && (
            <>
              <PaymentStatusSteps
                orderId={transaction && transaction.order_id}
                listOfStatus={historyList}
                creditData={creditData}
                detailsStatus={paymentStatus === 'canceled' ? 'Cancelado' : ''}
                setModalRepaymentActive={setModalRepaymentActive}
              />

              <S.Divider />
            </>
          )}
        </>
      )}

      {modalRepaymentActive && (
        <S.ModalActive>
          <div
            className="container"
            onClick={() => setModalRepaymentActive(false)}
          />
          <div className="div">
            <strong>Deseja reembolsar o pagamento?</strong>
            <span>
              O valor da compra será reembolsado para a conta corrente ou cartão
              de crédito do comprador
            </span>

            <button
              type="button"
              className="grey-button"
              onClick={() => setModalRepaymentActive(false)}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="red-button"
              onClick={() => handleRepaymentOrder()}
            >
              Confirmar reembolso
            </button>
          </div>
        </S.ModalActive>
      )}
    </>
  );
}
